import { CMIC_TREE_NODE_TYPES, CMIC_STATIC_TREE_NODE_ID, ICON_NAMES } from '../../shared/Constants';

const definedGridRows = (type, nodes) => {
	switch (type) {
		case CMIC_STATIC_TREE_NODE_ID.START_NODE:
			return [
				{
					id: CMIC_STATIC_TREE_NODE_ID.CMIC_ECM,
					ecmParentNodeType: CMIC_STATIC_TREE_NODE_ID.CMIC_ECM,
					[type]: 'CMiC ECM',
					Icon: ICON_NAMES.FOLDER,
				},
			];
		case CMIC_STATIC_TREE_NODE_ID.CMIC_ECM:
			return [
				{
					id: CMIC_STATIC_TREE_NODE_ID.ENTERPRISE_DOCUMENTS_PARENT,
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT,
					index: 0,
					[type]: 'Enterprise Documents',
					Icon: ICON_NAMES.FOLDER,
				},
				{
					id: CMIC_STATIC_TREE_NODE_ID.PROJECTS_PARENT,
					ecmParentNodeType: CMIC_TREE_NODE_TYPES.PROJECTS_PARENT,
					index: 1,
					[type]: 'Projects',
					Icon: ICON_NAMES.FOLDER,
				},
			];

		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENTS_PARENT:
		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_TYPE:
		case CMIC_TREE_NODE_TYPES.ENTERPRISE_DOCUMENT_REVISION:
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_ISSUE:
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_RFI:
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBMITTALS:
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DAILY_JOURNAL:
		case CMIC_TREE_NODE_TYPES.PROJECT_RFI:
		case CMIC_TREE_NODE_TYPES.PROJECT_ISSUE:
		case CMIC_TREE_NODE_TYPES.PROJECT_DAILY_JOURNAL:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBMITTALS:
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_DOCUMENTS:
		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE:
		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT_TYPE_REVISION:
			return nodes;

		case CMIC_TREE_NODE_TYPES.PROJECT_DOCUMENT:
			return nodes.map((nodeData, index) => ({
				id: `${nodeData?.nodeId}-index:${index}`,
				nodeId: nodeData?.nodeId,
				Name: nodeData?.name || '-',
				Size: nodeData?.size || '-',
				CreatedOn: nodeData?.createdOn || '-',
				CreatedBy: nodeData?.createdBy || 'NA',
				RevNo: nodeData?.revNo || '-',
				ecmParentNodeType: nodeData.ecmParentNodeType,
				children: nodeData?.children,
				data: nodeData?.data,
				index,
				Icon: nodeData?.revNo > 1 ? ICON_NAMES.FOLDER : ICON_NAMES.FILE,
			}));

		case CMIC_TREE_NODE_TYPES.PROJECTS_PARENT:
			return nodes.map((nodeData, index) => ({
				id: `${nodeData?.nodeId}-index:${index}`,
				nodeId: nodeData?.nodeId,
				Name: nodeData?.name || '-',
				Id: nodeData?.id || '-',
				// Count: nodeData?.count || 0,
				Code: nodeData?.projectCode || '-',
				ecmParentNodeType: nodeData?.ecmParentNodeType || '-',
				index,
				data: nodeData?.data,
				Icon: ICON_NAMES.FOLDER,
			}));
		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_COMMUNICATION:
			return nodes.map((nodeData, index) => ({
				id: `${nodeData?.nodeId}-index:${index}`,
				nodeId: nodeData?.nodeId,
				ecmParentNodeType: nodeData?.ecmParentNodeType,
				Name: nodeData?.name || '-',
				Count: nodeData?.count || 0,
				CommNo: nodeData?.commNo || '-',
				ReceivedDate: nodeData?.receivedDate || '-',
				SubmitStatus: nodeData?.submitStatus || '-',
				From: nodeData?.from || '',
				Subject: nodeData?.subject || '-',
				Message: nodeData?.message || '-',
				index,
				data: nodeData?.data,
				Icon: ICON_NAMES.FOLDER,
			}));

		case CMIC_TREE_NODE_TYPES.PROJECT:
			return nodes.map((nodeData, index) => ({
				id: `${nodeData?.nodeId}-index:${index}`,
				nodeId: nodeData?.nodeId,
				ecmParentNodeType: nodeData?.ecmParentNodeType,
				Name: nodeData?.name || '-',
				Count: nodeData?.count || 0,
				index,
				data: nodeData?.data,
				Icon: ICON_NAMES.FOLDER,
			}));

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_PCI:
			return nodes.map((nodeData, index) => ({
				id: `${nodeData?.nodeId}-index:${index}`,
				nodeId: nodeData?.nodeId,
				ecmParentNodeType: nodeData?.ecmParentNodeType,
				Name: nodeData?.name || '-',
				CmmName: nodeData?.CmmName,
				CmmCode: nodeData?.CmmCode || '-',
				pciRefDate: nodeData?.pciRefDate || '-',
				Status: nodeData?.CmmPrepostStatCode || '-',
				index,
			}));

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS:
			return nodes.map((nodeData, index) => ({
				id: `${nodeData?.nodeId}-index:${index}`,
				nodeId: nodeData?.nodeId,
				ecmParentNodeType: nodeData?.ecmParentNodeType,
				Name: nodeData?.name || '-',
				Count: nodeData?.count || '-',
				Vendor: nodeData?.vendor || '-',
				Status: nodeData?.status || '-',
				Date: nodeData?.date || '-',
				TotalPendingAmt: nodeData?.totalPendingAmt || '-',
				ContractAmt: nodeData?.contractAmt || '-',
				CurrentAmt: nodeData?.currentAmt || '-',
				PostedAmt: nodeData?.postedAmount || '-',
				PendingAmt: nodeData?.pendingAmount || '-',
				ContractCode: nodeData?.contractCode || '-',
				ToBePaid: nodeData?.toBePaid || '-',
				Completed: nodeData?.name || '-',
				index,
				data: nodeData?.data,
				Icon: ICON_NAMES.FOLDER,
			}));

		case CMIC_TREE_NODE_TYPES.PROJECT_FOLDER_SUBCONTRACTORS_CHANGE_ORDERS:
			return nodes.map((nodeData, index) => ({
				id: `${nodeData?.nodeId}-index:${index}`,
				nodeId: nodeData?.nodeId,
				ecmParentNodeType: nodeData?.ecmParentNodeType,
				Name: nodeData?.name || '-',
				Count: nodeData?.count || 0,
				Vendor: nodeData?.vendor || '-',
				Status: nodeData?.status || '-',
				Date: nodeData?.date || '-',
				ContChngCode: nodeData?.contChngCode || '-',
				ContractAmt: nodeData?.contractAmt || '-',
				PartnerCode: nodeData?.partnerCode || '-',
				ContractCode: nodeData?.contractCode || '-',
				JobCode: nodeData?.jobCode || '-',
				index,
				data: nodeData?.data,
				Icon: ICON_NAMES.FOLDER,
			}));

		case CMIC_TREE_NODE_TYPES.PROJECT_COMMUNICATION:
		case CMIC_TREE_NODE_TYPES.PROJECT_PCI:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS:
		case CMIC_TREE_NODE_TYPES.PROJECT_SUBCONTRACTORS_CHANGE_ORDERS:
			return nodes.map((nodeData, index) => {
				return {
					id: `${nodeData?.nodeId}-index:${index}`,
					nodeId: nodeData?.nodeId,
					ecmParentNodeType: nodeData?.ecmParentNodeType,
					Name: nodeData?.name || '-',
					Folder: nodeData?.folder || '-',
					CreatedOn: nodeData?.createdOn || '-',
					CreatedBy: nodeData?.createdBy || '-',
					Size: nodeData?.size || '-',
					index,
					data: nodeData?.data,
					children: nodeData?.children,
					Icon: nodeData.size > 0 ? ICON_NAMES.FILE_REVERSE : ICON_NAMES.FILE,
				};
			});

		default:
			return [];
	}
};

export default definedGridRows;
